import { useNavigate } from "react-router-dom-v5-compat";
import { HOTELS_PATH } from "@b2bportal/core-utilities";

/**
 * Go back to hotel shop from hotel checkout
 */
export const useGoBackToHotelSearch = () => {
  const navigate = useNavigate();
  return () => navigate(HOTELS_PATH, { replace: true });
};
